export default {
    TEMPLATE_DESIGNER: {
        SAVE: 'product/template/save',
        ARCHIVE: 'product/template/archive',
        FETCH_ALL: 'product/template/list'
    },
    BOOKS: {
        PRINT_BOOKS: 'book/printBooks',
        FETCH_PREPRINTED_BOOKS: 'book/preprintedBooks',
        REGISTER_BOOK: 'scheduler/register',
        FETCH_BOOKS_FOR_SCHEDULE: 'book/fetchBooksForSchedule',
        FETCH_BOOK_BY_ID: 'book',
        FETCH_BOOKS_BY_ID: 'book/ids',
        REPRINT_BOOK: 'book/reprintBook',
        FETCH_DOWNLOADABLE_BOOKS: 'book/downloadableBooks',
        DOWNLOAD_BOOKS: 'book/downloadBooks?printRequestAuditId=',
        PRINT_ON_DEMAND_BOOKS: 'book/printOnDemand?printRequestAuditId='
    },
    WINNERS: {
        GET_WINNER_DETAILS: 'book/getWinnerByBookId', 
        CANCEL_PRINTED_BOOKS: 'book/cancelPrintedBooks', 
        CANCEL_RECEIPT_BOOKS: 'book/cancelAllBooksOfReceipt',
        UPDATE_PRINTED_RECEIPTS: 'book/markReceiptPrinted', 
    },
    SCHEDULER: {
        SAVE: 'scheduler/save',
        FETCH_ALL: 'scheduler/list',
        FETCH_ALL_DATES: 'scheduler/listScheduleDates',
        FETCH_ALL_FOR_DATE: 'scheduler/findByDate',
        FETCH_UPCOMING: 'scheduler/listUpcomingSchedules',
        START_SCHEDULE: 'scheduler/start',
        CANCEL_SCHEDULE: 'scheduler/cancel',
        END_SCHEDULE: 'scheduler/end',
        NEXT_GAME: 'scheduler/nextGame',
        FETCH_STATUS: 'scheduler/scheduleStatus',
        SET_BROADCAST: 'scheduler/setBroadcast',
        PAUSE_GAME_STATE: '/scheduler/pause/state',
    },
    PRODUCTS: {
        FETCH_ALL_FOR_SCHEDULE_ID: 'product/findAllBySchedule',
        SAVE_DETAILS: 'product/saveProductDetails',
        PURCHASE_PRINT: 'product/purchasePrint',
        RECEIPTS_LIST: 'product/receipts',
        POS_PURCHASE: 'product/posPurchase'
    },
    CALLER: {
        CALL_NUMBER: 'caller/callNumber',
        RECALL_NUMBER: 'caller/recallNumber',
        NEXT_PATTERN: 'caller/nextPattern',
        VERIFY_WINNER: 'caller/verifyWinner',
        MISSED_WINNER: 'caller/missedWinner',
        UPDATE_ADD_MESSAGE: 'caller/updateAdvert'
    },
    PANEL: {
        FETCH_BY_ID: 'panel/'
    },
    USERS: {
        FETCH_ALL: 'user/list',
        SAVE: 'user/save',
        UPDATE: 'user/update',
        DELETE: 'user/delete'
    },
    TENANTS: {
        FETCH_ALL: 'tenant/list',
        SAVE: 'tenant/save',
    },
    AUTH: {
        LOGIN: 'auth/login',
        FORGOT_PASSWORD: 'user/forgotPassword',
        CHANGE_PASSWORD: 'user/changePassword',
        RESET_PASSWORD: 'user/resetPassword',
        REFRESH_TOKEN: 'auth/refreshToken'
    },
    SYSTEM_ADMIN: {
        FETCH_COLOURS: 'config/listColours',
        SAVE_COLOURS: 'config/saveColours'
    },
    CUSTOMERS: {
        FETCH_ALL: 'customer/list',
        REGISTER: 'player/signup',
        UPDATE: 'player/update',
        DELETE: 'player/delete',
        RESET_PASSWORD: 'player/resetPassword'
    },
    REPORTING: {
        FETCH_GAME_SALES: 'reporting/gameSales',
        FETCH_GAME_BREAKDOWN: 'reporting/gameBreakdown',
        FETCH_BOOK_BREAKDOWN: 'reporting/booksBreakdown',
        FETCH_SCHEDULE_INFO: 'reporting/scheduleInfo',
        NEW_SESSION_REQUEST: 'reporting/getScheduleInRange',
        GET_SESSION_REPORTING: 'reporting/getReportingByScheduleId'
    }
}